import React from 'react';
import FooterOne from '../common/footer/FooterOne';
import HeaderOne from '../common/header/HeaderOne';
import SEO from '../common/SEO';
import BcrumbBannerOne from '../elements/breadcrumb/BcrumbBannerOne';
import CtaLayoutOne from '../component/cta/CtaLayoutOne';
import ColorSwitcher from '../elements/switcher/ColorSwitcher';
import AboutFour from '../component/about/AboutFour';
import { useLanguage } from '../context/LanguageContext';
import { Features } from '../assets/features/Features';


const AboutUs = () => {
    const { language } = useLanguage();

    return (
        <>
        <SEO title={Features.ABOUT.TITLE[language]} />
        <ColorSwitcher />
            <main className="main-wrapper">
                <HeaderOne />
                <BcrumbBannerOne 
                title={Features.ABOUT.TITLE[language]}
                paragraph={Features.FOOTER.COMMITMENT[language]}
                styleClass="thumbnail-4"
                mainThumb="/images/banner/banner-thumb-3.png"
                />
                <AboutFour />
                <CtaLayoutOne />
                <FooterOne parentClass="" />
            </main>
        </>
    )
}

export default AboutUs;